module.exports = __webpack_public_path__ + "img/luoxuanjiajingjigou.asm.a7298ae3.jpg";